import { useMemo } from 'react';

import { isNil } from 'lodash';

import { ReasonCode } from '@app/models/api/api-types';
import { accommodationSlice, useAppSelector } from '@app/state';

export const useIsUnavailable = () => {
    const filters = useAppSelector(accommodationSlice.selectors.selectFilters);
    const unavailabilityReason = useAppSelector(
        accommodationSlice.selectors.selectUnavailabilityReason,
    );
    const isDatesAvailabilityError = useAppSelector(
        accommodationSlice.selectors.selectIsDatesAvailabilityError,
    );

    const { checkIn, checkOut } = filters ?? {};
    const isDatesNotSet = useMemo(() => isNil(checkIn) && isNil(checkOut), [checkIn, checkOut]);
    const isUnavailableTooManyGuests = [ReasonCode.RequestNotSatisfied].includes(
        unavailabilityReason as ReasonCode,
    );

    return isDatesNotSet || isUnavailableTooManyGuests || isDatesAvailabilityError;
};
